<template>
  <el-card
    class="card-container"
    shadow="never"
  >
    <el-row
      slot="header"
      type="flex"
      justify="space-between"
      align="middle"
    >
      <h1 class="card-container__title">
        Mapping dữ liệu để import
      </h1>
      <el-upload
        class="file-uploader"
        action
        :accept="`.json`"
        :show-file-list="false"
        :http-request="uploadFiles"
      >
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
        >
          Thêm file mẫu
        </el-button>
      </el-upload>
    </el-row>
    <div v-if="importTemplates.length == 0">
      Chưa có file mẫu nào
    </div>
    <el-card
      v-for="(iTemplate, index) in importTemplates"
      :key="index"
      size="small"
      shadow="never"
    >
      <el-row
        slot="header"
        type="flex"
        justify="space-between"
        align="middle"
      >
        <h1 class="card-container__title">
          File mẫu {{ index + 1 }}
        </h1>
        <div>
          <el-button
            v-if="!isEdit || selectedIndex !== index"
            type="primary"
            size="small"
            icon="el-icon-edit"
            @click="() => handleEdit(index)"
          >
            Chỉnh sửa
          </el-button>
          <el-button
            v-if="!isEdit || selectedIndex !== index"
            type="danger"
            size="small"
            icon="el-icon-delete"
            @click="() => handleDelete(index)"
          >
            Xoá
          </el-button>
          <el-button
            v-if="isEdit && selectedIndex === index"
            type="info"
            size="small"
            icon="el-icon-close"
            @click="() => handleCancel()"
          >
            Hủy
          </el-button>
          <el-button
            v-if="isEdit && selectedIndex === index"
            type="primary"
            size="small"
            icon="el-icon-check"
            @click="() => handleSave()"
          >
            Lưu
          </el-button>
        </div>
      </el-row>
      <el-row :gutter="12">
        <el-col
          v-for="field in importExportFields"
          :key="field.key"
          :lg="4"
          :md="6"
          :sm="12"
          class="mb-m"
        >
          <div
            class="mb-xs"
            style="font-size: 12px;"
          >
            {{ field.name }}
          </div>
          <el-select
:value="iTemplate.fields[field.key]"
class="w-100"
size="small"
:disabled="!isEdit"
filterable
clearable
@change="(v) => handleChange(field.key, v)"
          >
            <el-option
              v-for="option in iTemplate.keyOptions.filter((o) => iTemplate.fields[field.key] === o || !Object.values(iTemplate.fields).includes(o))"
              :key="option"
              :label="option"
              :value="option"
            />
          </el-select>
        </el-col>
      </el-row>
    </el-card>
  </el-card>
</template>

<script>
import { notification } from "@/utils/common";

export default {
  name: "ConfigObjectMapping",
  components: {
  },
  props: {
    object: Object,
  },
  data() {
    return {
      isEdit: false,
      importTemplates: [],
      selectedIndex: null
    };
  },
  computed: {
    importExportFields() {
      const data = this.object?.extra?.fields || [];
      return data.filter((f) => f.show.import_export);
    },
  },
  beforeMount() {
    this.importTemplates = this.object.extra.import_templates || []
  },
  methods: {
    handleEdit(index) {
      this.selectedIndex = index;
      this.isEdit = true;
    },
    handleDelete(index) {
      this.importTemplates = this.importTemplates.filter((t, i) => i !== index);
      this.handleSave()
    },
    handleCancel() {
      this.selectedIndex = null;
      this.isEdit = false
    },
    handleChange(key, value) {
      this.importTemplates = this.importTemplates.map((t, index) => {
        if (this.selectedIndex === index) {
          return {
            ...t,
            fields: {
              ...t.fields,
              [key]: value
            }
          }
        }
        return t
      })
    },
    handleSave(isCreate = false) {
      this.$emit("save", {
        payload: { import_templates: this.importTemplates },
        success: () => {
          notification(
            this,
            "success",
            isCreate ? "create" : "update",
            "Tài liệu mẫu"
          );
          if (!isCreate) {
            this.isEdit = false;
          }
        },
        error: () => {
          notification(
            this,
            "error",
            isCreate ? "create" : "update",
            "Tài liệu mẫu"
          );
        },
      });
    },
    async uploadFiles(fileInfo) {
      const file = fileInfo.file;
      const reader = new FileReader();
      const self = this;
      reader.onload = function (e) {
        const data = JSON.parse(e.target.result)
        if (data.length > 0) {
          const template = {
            keyOptions: Object.keys(data[0]),
            fields: {}
          };
          self.importExportFields.forEach(f => {
            template.fields[f.key] = ""
          });
          self.importTemplates = [template, ...self.importTemplates];
          self.handleSave(true);
          self.isEdit = true;
          self.selectedIndex = 0
        }
      };

      reader.onerror = function (ex) {
        console.log(ex);
      };

      reader.readAsText(file);
    },
  },
};
</script>

<style lang="scss" scoped></style>
